







































import { Component, Vue, Prop } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';
import { AdminDto } from '@/dto';
import { BaseUser } from '@/services/shared/auth';
import AdminService from '../../../services/admin.service';
import JwtStorageService from '@/services/shared/auth/jwt-storage.service';
import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'NavBarAccountLayout',
})
export default class NavBarAccountLayout extends BaseComponent {
  private admin = new AdminDto(BaseUser);

  logout() {
    JwtStorageService.removeToken();
    toast.success('로그아웃 성공적으로 했습니다.');
    this.$router.push('/login');
  }

  created() {
    AdminService.findMe().subscribe(res => {
      this.admin = res.data;
    });
  }
}
